let config = {};

config.server = {};
config.server.endpoint =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://clipps-dashboard.herokuapp.com';

config.auth = {};
config.auth.require = true;

config.data = {};
config.data.allowAnyDuration = true;
config.data.maxDuration = 60; // In seconds
config.data.fakeLogin = false;
config.data.fakeRegister = false;

config.location = {};
config.location.apiKey = 'f46e4120605a37566e3be13020f79f31';

module.exports = config;
